import React from 'react';
import { keys } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVisibleCategoricalSelectedParametersNames, getCategoricalSummary } from 'store/dataset';
import { getCategoricalRowDataSet } from 'store/form/inferentialStatistics/selectors';
import { getOptionListForDropDown, getLevelsOptionsForChosenVariable } from 'calculators/inferentialStatistics/oneSampleT';

import OneSampleProportionComponent from './Component';
import {
  setNumberOfSuccess,
  setNumberOfTrials,
  setLevelsRowDataSet,
  setCategoricalRowDataSet
} from 'store/form/inferentialStatistics/action';

class OneSampleProportionContainer extends React.PureComponent {
  getVariablesOptions = () => {
    const { selectedCategoricalParameters, isFrequencyTable } = this.props;
    return getOptionListForDropDown({
      selectedParametersNames: selectedCategoricalParameters,
      isFrequencyTable
    });
  };

  getLevelsOptions = () => {
    const { categoricalOption, categoricalSummary } = this.props;

    return getLevelsOptionsForChosenVariable(categoricalOption, categoricalSummary);
  };

  handleLevelsOptionsChange = (_, newLevel) => {
    this.props.handleLevelsOptionsChange(newLevel);
  };

  handleVariablesOptionsChange = (_, newVariable) => {
    this.props.handleVariablesOptionsChange(newVariable);
  };

  handleNumberOfSuccessChange = () => {
    this.props.resetLevelsOption();
  }

  handleNumberOfTrialsChange = () => {
    this.props.handleNumberOfTrialsChange();
  }

  render () {
    return (
      <OneSampleProportionComponent
        onNumberOfTrialsChange={this.handleNumberOfTrialsChange}
        onNumberOfSuccessChange={this.handleNumberOfSuccessChange}
        levelsOptions={this.getLevelsOptions()}
        variableOptions={this.getVariablesOptions()}
        onLevelsOptionsChange={this.handleLevelsOptionsChange}
        onVariablesOptionsChange={this.handleVariablesOptionsChange}
      />
    );
  }
}

OneSampleProportionContainer.propTypes = {
  selectedCategoricalParameters: PropTypes.arrayOf(PropTypes.string),
  handleLevelsOptionsChange: PropTypes.func.isRequired,
  handleVariablesOptionsChange: PropTypes.func.isRequired,
  resetLevelsOption: PropTypes.func.isRequired,
  handleNumberOfTrialsChange: PropTypes.func.isRequired,
  isFrequencyTable: PropTypes.bool.isRequired,
  categoricalSummary: PropTypes.object,
  categoricalOption: PropTypes.string
};

const mapStateToProps = state => ({
  selectedCategoricalParameters: getVisibleCategoricalSelectedParametersNames(
    state
  ),
  categoricalOption: getCategoricalRowDataSet(state),
  categoricalSummary: getCategoricalSummary(state)
});

const mapDispatchToProps = {
  handleVariablesOptionsChange: newVariable => (dispatch, getState) => {
    if (!newVariable) {
      return dispatch([
        setLevelsRowDataSet(''),
        setNumberOfSuccess(1),
        setNumberOfTrials(2)
      ]);
    }

    const { categoricalSummary } = getState().dataset.summary;
    const chosenOption = categoricalSummary[newVariable];
    const [firstLevel] = keys(chosenOption.levels);

    if (!chosenOption || !firstLevel || !chosenOption.levels[firstLevel]) {
      return dispatch(setLevelsRowDataSet(''));
    }

    const numberOfTrials = chosenOption.count;
    const numberOfSuccess = chosenOption.levels[firstLevel].count;
    const firstLevelName = chosenOption.levels[firstLevel].name;

    return dispatch([
      setLevelsRowDataSet(firstLevelName),
      setNumberOfSuccess(numberOfSuccess),
      setNumberOfTrials(numberOfTrials)
    ]);
  },
  handleLevelsOptionsChange: newLevel => (dispatch, getState) => {
    if (!newLevel) {
      return dispatch(setNumberOfSuccess(1));
    }

    const state = getState();
    const variableOption = getCategoricalRowDataSet(state);

    const { categoricalSummary } = state.dataset.summary;
    const chosenOption = categoricalSummary[variableOption];

    if (!variableOption || !chosenOption || !chosenOption.levels[newLevel]) {
      return dispatch();
    }

    const numberOfSuccess = chosenOption.levels[newLevel].count;

    return dispatch(setNumberOfSuccess(numberOfSuccess));
  },
  handleNumberOfTrialsChange: () => dispatch => {
    dispatch([setCategoricalRowDataSet(''), setLevelsRowDataSet('')]);
  },
  resetLevelsOption: () => dispatch => {
    dispatch(setLevelsRowDataSet(''));
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OneSampleProportionContainer);
